<template>
  <div class="flex-1 overflow-x-hidden grid lg:grid-cols-2 gap-10">
    <onboarding-step
      :validate="validate"
      :max-steps="maxSteps"
      :step="step"
      @next="() => $emit('next')"
    >
      <template #heading>
        Where do you want to work after graduation?
      </template>

      <template #help>
        You can edit your location preferences anytime after creating your personal report.
      </template>

      <template #subheading>
        <div class="grid gap-3">
          <p>
            2 in 3 employed graduates don't leave their school's state for their first job.
            Geography should be a very high priority for your decision on where to apply
            and ultimately attend.
          </p>

          <alert v-if="user.national">
            Since you're interested in high-prestige jobs, we're also going to include national schools
            on your report.
          </alert>
        </div>
      </template>
      <template #content>
        <div class="space-y-3">
          <l-state-input
            v-model="user.statesPreferred"
            :items="states"
            name="states"
            label="Select states"
            placeholder="Select states"
            class="label:sr-only help:sr-only"
            size="lg"
          />
        </div>
      </template>
    </onboarding-step>

    <state-map
      v-model="user.statesPreferred"
      class="hidden lg:flex items-center justify-center py-5 px-16 bg-blue-100"
      :items="states"
      multiple
    />
  </div>
</template>

<script setup>
import Alert from "@/components/Alert.vue"
import LStateInput from "@/components/inputs/LStateInput.vue"
import OnboardingStep from "@/components/onboardings/OnboardingStep.vue"
import StateMap from "@/components/maps/StateMap.vue"
import { useStates } from "@/composables/useStates"

const user = defineModel({ type: Object, required: true })

defineProps({
  step: { type: Number },
  maxSteps: { type: Number },
})

defineEmits(["next"])

const { states } = useStates()

const validate = () => {
  if (user.value.national || user.value.statesPreferred.length) {
    return
  }

  return "Please select one or more states."
}
</script>
